import { UI } from "../data/content";
import { CTAButton, usePageMeta } from "../components/kit";

export default function NotFound() {
  const T = UI.pages.notFound;
  usePageMeta(T.metaTitle, T.body);
  return (
    <div className="k-section k-container" data-testid="not-found-page">
      <p className="eyebrow mb-4">404</p>
      <h1 className="k-h1 max-w-2xl mb-6">{T.title}</h1>
      <p className="text-ink-muted max-w-xl mb-10">{T.body}</p>
      <div className="flex flex-wrap gap-4">
        <CTAButton to="/" testId="notfound-home-btn">{T.home}</CTAButton>
        <CTAButton to="/insights" variant="secondary" testId="notfound-insights-btn">{T.insights}</CTAButton>
      </div>
    </div>
  );
}
